export default "__VITE_ASSET__ghZLioMvfu_m$VABqVwyoA__"